/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function SocialFacebook(props) {
    return (
        <SvgIcon {...props}>
            <path d="M9.448,2H0.552C0.247,2,0,2.247,0,2.552v8.896C0,11.753,0.247,12,0.552,12h4.79V8.127H4.038V6.618h1.303 V5.505c0-1.291,0.789-1.994,1.941-1.994c0.552,0,1.025,0.04,1.164,0.059v1.35H7.648C7.021,4.92,6.9,5.218,6.9,5.655v0.963h1.495 L8.2,8.127H6.9V12h2.548C9.753,12,10,11.753,10,11.448V2.552C10,2.247,9.753,2,9.448,2z" />
        </SvgIcon>
    );
}

SocialFacebook.defaultProps = {
    viewBox: '0 0 16 16'
};

export default SocialFacebook;
